/*!
 *  - colorSearch.js
 * @generated Tue Oct 15 2019 13:01:41 GMT+0900 (東京 (標準時))
 */
'use strict';

/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function ($, DIC) {
	var $ctWrapper = $('#ctWrapper');
	var $map = location.pathname;
	var csvFile = 'col_data5.csv';

	var colorSearch = function colorSearch() {
		var searchNum = $('input[name="col_no"]').val().toUpperCase();
		var colorArr = [];
		var numArr = [];

		var req = new XMLHttpRequest();
		req.open('get', csvFile, true);
		req.send(null);
		req.onload = function () {
			var tmp = req.responseText.split('\n'),
			    idCol = tmp[1].split(',').indexOf('ID'),
			    numCol = tmp[1].split(',').indexOf('番号');

			tmp.forEach(function (val, idx) {
				var data = val.split(',');
				colorArr.push({ id: data[idCol], num: String(data[numCol]).replace(/\s+/g, '') });
				numArr.push(String(data[numCol]).replace(/\s+/g, ''));
			});

			var resultID = null;
			for (var i = 0; i < colorArr.length; i++) {
				if (colorArr[i].num === searchNum) {
					resultID = colorArr[i].id;
				}
			}

			if (numArr.indexOf(searchNum) !== -1 && searchNum !== '') {
				$('form[name="c_search"]').attr('action', 'result.html?color-id=' + encodeURIComponent(resultID));
			} else {
				$('form[name="c_search"]').attr('action', 'error.html?color-number=' + encodeURIComponent(searchNum));
			}
		};
	};

	if ($map.indexOf('/color/search/') !== -1) {

		// <検索ページ>
		if ($ctWrapper.hasClass('colorSearchIndex')) {

			colorSearch();

			$('input[name="col_no"]').on('input', function () {
				colorSearch();
			});
		}

		// <検索結果ページ>
		if ($ctWrapper.hasClass('colorSearchResult')) {
			var param = location.search;
			var thisID = param.split('color-id')[1].split('&')[0].replace(/\=/g, '');

			if (param !== '') {
				var req = new XMLHttpRequest();
				req.open('get', csvFile, true);
				req.send(null);
				req.onload = function () {
					var tmp = req.responseText.split('\n'),
					    idCol = tmp[1].split(',').indexOf('ID'),
					    numCol = tmp[1].split(',').indexOf('番号'),
					    htmlColorCol = tmp[0].split(',').indexOf('HTML'),
					    asteriskCol = tmp[1].split(',').indexOf('アスタリスク'),
					    munsellCol = tmp[0].split(',').indexOf('マンセル値'),
					    japaneseCol = tmp[1].split(',').indexOf('日本語表記'),
					    guideName = tmp[1].split(',').indexOf('見本帳名'),
					    perTotalCol = tmp[1].split(',').indexOf('総計'),
					    rgbR = tmp[1].split(',').indexOf('R'),
					    rgbG = tmp[1].split(',').indexOf('G'),
					    rgbB = tmp[1].split(',').indexOf('B'),
					    cmykC = tmp[1].split(',').indexOf('C'),
					    cmykM = tmp[1].split(',').indexOf('M'),
					    cmykY = tmp[1].split(',').indexOf('Y'),
					    cmykK = tmp[1].split(',').indexOf('K');

					tmp.forEach(function (val, idx) {
						var data = val.split(',');
						if (data[idCol] === thisID) {
							var totalHTML = '<tr><td>\u3000\u7DCF\u8A08</td><td>&nbsp;\uFF1A&nbsp;</td><td align="right">\n\t\t\t\t\t\t\t\t' + data[perTotalCol] + '</td><tr>';

							for (var i = 1; i < 6; i++) {
								var inkName = data[tmp[1].split(',').indexOf('\u30A4\u30F3\u30AD\u540D' + i)];
								if (inkName !== '') {
									$('.inkTable tbody').append('<tr><td>\u3000' + inkName + '</td><td>&nbsp;\uFF1A&nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td align="right">' + data[tmp[1].split(',').indexOf('\u5272\u5408' + i)] + '</td></tr>');
								}
							}

							$('.colorBlock').attr('bgcolor', data[htmlColorCol]);
							$('.colorName').html('DIC-' + data[numCol] + ' <sup>' + data[asteriskCol] + '</sup>\u3000\u7CFB\u7D71\u8272\u540D ' + data[japaneseCol]);
							$('.colorGuide').text(data[guideName]);
							$('.inkTable tbody').append(totalHTML);
							$('.cmykC').text(data[cmykC]);
							$('.cmykM').text(data[cmykM]);
							$('.cmykY').text(data[cmykY]);
							$('.cmykK').text(data[cmykK]);
							$('.rgbR').text(data[rgbR]);
							$('.rgbG').text(data[rgbG]);
							$('.rgbB').text(data[rgbB]);
							$('.colorHTML').text('#' + data[htmlColorCol]);
							$('.colorMunsell').text(data[munsellCol]);
						}
					});
				};
			} else {
				location.href = 'error.html';
			}
		}

		// <エラーページ>
		if ($ctWrapper.hasClass('colorSearchError')) {
			var _param = location.search;
			var thisNum = _param.split('color-number')[1].split('&')[0].replace(/\=/g, '');
			if (_param !== '') {
				$('.errorMsg').text(decodeURIComponent(thisNum));
			}
		}
	}
})(window.jQuery, window.DIC);